import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDZQbruVW8EQqTjiXYq_QHY2pQEbw1NXiM",
  authDomain: "mycoquiz.firebaseapp.com",
  databaseURL: "https://mycoquiz-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "mycoquiz",
  storageBucket: "mycoquiz.firebasestorage.app",
  messagingSenderId: "592080785230",
  appId: "1:592080785230:web:fecd2867c75cf9de0e181f",
  measurementId: "G-K3ZD414LE3"
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
